import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(21.5, 33, 18.25, 24),
    flex: 1,
    flexDirection: 'column',

    '&:first-child': {
      margin: ({ direction }: LayoutDirection) =>
        direction === 'rtl' ? theme.spacing(0, 0, 0, 8.5) : theme.spacing(0, 8.5, 0, 0),
    },
  },
  availableBalanceWrapper: {
    marginLeft: '10px',
  },
  balanceDropdown: {
    '& div': {
      alignItems: 'center',
      margin: ({ direction }: LayoutDirection) => (direction === 'rtl' ? 0 : 'inherit'),
    },
    '& > p': {
      fontSize: 40,
    },
    '& h3 ': {
      color: theme.palette.grey['A200'],
      fontSize: theme.spacing(19.5),
      lineHeight: '59px',
      fontWeight: 400,
      display: 'flex',
      alignItems: 'center',

      '&  > span': {
        fontSize: theme.spacing(27),
        lineHeight: '81px',
        fontWeight: 600,
        color: theme.palette.grey['A400'],
        margin: ({ direction }: LayoutDirection) =>
          direction === 'rtl' ? theme.spacing(0, 0, 0, 10) : theme.spacing(0, 10, 0, 0),
      },
    },
    '& button ': {
      margin: ({ direction }: LayoutDirection) =>
        direction === 'rtl' ? theme.spacing(0, 5, 0, 0) : theme.spacing(0, -10, 0, 5),
      '& svg': {
        width: theme.spacing(10),
        height: theme.spacing(5.6),
      },
    },
  },
  title: {
    color: theme.palette.grey['A200'],
    fontWeight: 500,
    lineHeight: '27px',
    marginBottom: theme.spacing(12),
  },
  userFullName: {
    fontSize: theme.spacing(11.5),
    lineHeight: '34px',
    fontWeight: 'bold',
    color: theme.palette.grey['A400'],
  },
  userRolesTitle: {
    fontSize: theme.spacing(9.5),
    fontWeight: 400,
    lineHeight: '29px',
    color: theme.palette.grey['A200'],
    marginTop: theme.spacing(6),
  },
  topUpButton: {
    padding: theme.spacing(12.25, 22.5),
    maxWidth: theme.spacing(149),
    marginTop: theme.spacing(18),
    backgroundColor: 'rgba(59, 66, 240, 1)',
    borderRadius: theme.spacing(7.5),

    '&:hover': {
      backgroundColor: 'rgba(59, 66, 240, 0.8)',
    },
  },
  topUpButtonLabel: {
    color: theme.palette.secondary.contrastText,
    fontSize: theme.spacing(11),
    fontWeight: 'bold',
    lineHeight: '33px',
    textTransform: 'capitalize',
  },
  topUpBalanceByTransfer: {
    fontSize: theme.spacing(8),
    paddingTop: theme.spacing(10),
    lineHeight: theme.spacing(12) + 'px',
    fontFamily: 'Roboto',
    fontWeight: theme.spacing(250),
    color: theme.palette.grey['A200'],
  },
  email: {
    fontSize: theme.spacing(9),
    fontFamily: 'Roboto',
    fontWeight: theme.spacing(350),
    color: theme.palette.grey['A400'],
  },
}));
